import { useState } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypotValue = (formData.get('phone_alt') as string || '').trim();

    if (honeypotValue) {
      setStatus('success');
      setMessage('订阅成功！感谢你的关注。');
      setEmail('');
      return;
    }

    try {
      const res = await fetch('https://readdy.ai/api/form/d9spkpdlbrt1qcgaj7o0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email: formData.get('email') as string }).toString(),
      });
      const text = await res.text();
      let parsed;
      try { parsed = JSON.parse(text); } catch { parsed = null; }
      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        setMessage('订阅成功！感谢你的关注，我们会定期发送精选健康资讯到你的邮箱。');
        setEmail('');
      } else {
        setStatus('error');
        setMessage(parsed?.meta?.message || '订阅失败，请稍后重试。');
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请稍后重试。');
    }
  };

  return (
    <section className="py-16 md:py-20 bg-accent-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-3">
            订阅健康资讯
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mb-8">
            每周精选私密健康科普文章，直接发送到你的邮箱。不打扰、不泛滥，只给你最需要的内容。
          </p>

          <form
            onSubmit={handleSubmit}
            className="flex flex-col sm:flex-row items-center gap-3 max-w-md mx-auto"
            data-readdy-form
          >
            <div className="honeypot-field" aria-hidden="true">
              <input
                type="text"
                name="phone_alt"
                tabIndex={-1}
                autoComplete="off"
                readOnly
                aria-hidden="true"
              />
            </div>
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="输入你的邮箱地址"
              required
              className="w-full sm:flex-1 px-4 py-3 rounded-full border border-background-300/60 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-300 focus:outline-none focus:border-primary-400 transition-colors"
            />
            <button
              type="submit"
              className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-white rounded-full font-medium text-sm whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              免费订阅
            </button>
          </form>

          {status !== 'idle' && (
            <p className={`mt-4 text-sm ${status === 'success' ? 'text-primary-700' : 'text-red-600'}`}>
              {message}
            </p>
          )}
        </div>
      </div>
    </section>
  );
}